<mojo-sort-selector
  [sortParameters]="sortParameters"
  [defaultSortParameter]="sortBy"
  (sortParameterChanged)="sortByChanged.emit($event)"
>
</mojo-sort-selector>
